import React from 'react';
import './Logo.css'

const Logo = () => {
    return (
        <div className="logo">
            <h1 className="logo-svg">Pomodoro Timer</h1>
        </div>

    );
};

export default Logo;